export var removeTrailingSlash = function removeTrailingSlash(text) {
  return text.replace(/\/$/, '');
};
export var removePrecedingSlash = function removePrecedingSlash(text) {
  return text.replace(/^\//, '');
};